(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1819],{

/***/ 12453:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var getGAUserID = function getGAUserID() {
  try {
    var trackers = ga.getAll();
    var i, len;

    for (i = 0, len = trackers.length; i < len; i += 1) {
      if (trackers[i].get("trackingId") === "UA-186465270-2") {
        return trackers[i].get("clientId");
      }
    }
  } catch (e) {}

  return false;
};

/* harmony default export */ __webpack_exports__["Z"] = (getGAUserID);

/***/ }),

/***/ 92559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);



var sendData = /*#__PURE__*/function () {
  var _ref2 = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_ref) {
    var api, data, token, endpoint, headers, options, response;
    return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            api = _ref.api, data = _ref.data, token = _ref.token;
            endpoint = api;
            headers = {
              "Content-Type": "application/json",
              "captcha-response": token
            };
            options = {
              method: "POST",
              headers: headers,
              body: JSON.stringify(data)
            };
            _context.next = 6;
            return fetch(endpoint, options);

          case 6:
            response = _context.sent;
            _context.next = 9;
            return response.json();

          case 9:
            return _context.abrupt("return", _context.sent);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function sendData(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["Z"] = (sendData);

/***/ }),

/***/ 53086:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var convertRate = function convertRate(value, exchangeRate) {
  var originExchangeRate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var numberFormat = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var rounded = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var result = value * exchangeRate / originExchangeRate / numberFormat;
  result = rounded ? parseFloat(result).toFixed(1) : result;
  return isNaN(parseFloat(result)) ? 0 : parseFloat(result);
};

/* harmony default export */ __webpack_exports__["Z"] = (convertRate);

/***/ }),

/***/ 38951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _convertRate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53086);


var scanPrice = function scanPrice(pricing, value) {
  var exchangeRate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var originExchangeRate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var numberFormat = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
  var rounded = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var pricingLevel = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var tmp = 0;
  var price = 0;

  if (pricing) {
    pricing.forEach(function (v) {
      var val = (0,_convertRate__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(v.value, exchangeRate, originExchangeRate, numberFormat, rounded);

      if (parseFloat(value) > tmp && parseFloat(value) <= val) {
        if (pricingLevel) {
          price = Math.round(parseFloat((value > 0 ? v.minPrice : 0) + (0,_convertRate__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value, 1 / exchangeRate, 1 / originExchangeRate, 1 / numberFormat, rounded) * (v.percent / 100)) / 10) * 10;
        } else {
          price = v.price;
        }
      }

      tmp = val;
    });
  }

  return price;
};

/* harmony default export */ __webpack_exports__["Z"] = (scanPrice);

/***/ }),

/***/ 7648:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var totalPrice = function totalPrice() {
  var prices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return prices.reduce(function (a, b) {
    return a + b;
  }, 0);
};

/* harmony default export */ __webpack_exports__["Z"] = (totalPrice);

/***/ }),

/***/ 62951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ trigger; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function trigger(eventType, data, fullName) {
  var event = new CustomEvent(eventType, {
    detail: {
      dataForm: _objectSpread({
        fullname: fullName,
        email: data.email
      }, data),
      response: data
    }
  });

  try {
    document.dispatchEvent(event);
  } catch (error) {
    console.log(error);
  }
}

/***/ }),

/***/ 7778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ BiLoaderAlt; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function BiLoaderAlt(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 59699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ FaCheckCircle; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaCheckCircle(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 66865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j7": function() { return /* binding */ InputEmail; },
/* harmony export */   "oH": function() { return /* binding */ InputText; },
/* harmony export */   "Z6": function() { return /* binding */ InputPhone; },
/* harmony export */   "Jg": function() { return /* binding */ CheckBox; }
/* harmony export */ });
/* unused harmony export InputNumber */
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91164);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _excluded = ["name", "placeholder", "register", "errors", "requiredText"],
    _excluded2 = ["as", "name", "placeholder", "register", "errors", "requiredText"],
    _excluded3 = ["name", "placeholder", "register", "errors", "requiredText", "invalidText"],
    _excluded4 = ["name", "text", "register", "errors", "checkboxTextClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var InputEmail = function InputEmail(_ref) {
  var _errors$name, _errors$email;

  var name = _ref.name,
      placeholder = _ref.placeholder,
      register = _ref.register,
      errors = _ref.errors,
      requiredText = _ref.requiredText,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", _objectSpread(_objectSpread({
      type: "email"
    }, register(name ? name : "email", {
      required: {
        value: true,
        message: requiredText || "Email is required"
      },
      pattern: {
        // Value: /(^(?:[0-9]+[a-z]|[a-z]+[0-9]|[a-z])[a-z0-9._%+-]*)+@[a-z0-9.-]+\.[a-z]{2,}$/,
        value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
        message: "Invalid e-mail"
      }
    })), {}, {
      placeholder: placeholder || "Email*",
      pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
      className: "w-full border-0 border-b border-b-gray-300 p-2 text-bbc-gray placeholder-gray-300 focus:ring-0 ",
      autoComplete: "off"
    }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-left text-sm text-red-500",
      children: name ? (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message : (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.message
    })]
  });
}; // Text Field must be single word or multiple word space with "_"

var InputText = function InputText(_ref2) {
  var _errors$name2;

  var as = _ref2.as,
      name = _ref2.name,
      placeholder = _ref2.placeholder,
      register = _ref2.register,
      errors = _ref2.errors,
      requiredText = _ref2.requiredText,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref2, _excluded2);

  var CustomTag = as || "input";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomTag, _objectSpread(_objectSpread({
      type: "text"
    }, register(name, {
      required: {
        value: true,
        message: requiredText || "This field is required"
      }
    })), {}, {
      placeholder: placeholder,
      className: "invalid-textfield w-full border-0 border-b border-b-gray-300 p-2 text-bbc-gray placeholder-gray-300 focus:ring-0",
      autoComplete: "off"
    }, props)), errors[name] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-sm text-red-500",
      children: (_errors$name2 = errors[name]) === null || _errors$name2 === void 0 ? void 0 : _errors$name2.message
    })]
  });
};
var InputPhone = function InputPhone(_ref3) {
  var _errors$name3, _errors$phone_number;

  var name = _ref3.name,
      placeholder = _ref3.placeholder,
      register = _ref3.register,
      errors = _ref3.errors,
      requiredText = _ref3.requiredText,
      invalidText = _ref3.invalidText,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref3, _excluded3);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", _objectSpread(_objectSpread({
      type: "text"
    }, register(name || "phone_number", {
      required: {
        value: true,
        message: requiredText || "Phone number is required"
      },
      pattern: {
        value: /[0-9]+/,
        message: invalidText || "Invalid phone number"
      }
    })), {}, {
      placeholder: placeholder,
      pattern: "[0-9]+",
      className: "invalid-textfield w-full border-0 border-b border-b-gray-300 p-2 text-bbc-gray placeholder-gray-300 focus:ring-0",
      autoComplete: "off"
    }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-sm text-red-500",
      children: name ? (_errors$name3 = errors[name]) === null || _errors$name3 === void 0 ? void 0 : _errors$name3.message : (_errors$phone_number = errors.phone_number) === null || _errors$phone_number === void 0 ? void 0 : _errors$phone_number.message
    })]
  });
};
var InputNumber = function InputNumber(_ref4) {
  var numberValue = _ref4.numberValue,
      min = _ref4.min,
      max = _ref4.max,
      setNumberValue = _ref4.setNumberValue;

  var handleOnclickNumber = function handleOnclickNumber(number) {
    setNumberValue(number);
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "relative flex w-28 items-center lg:mb-6 lg:w-40",
      children: [/*#__PURE__*/_jsx("button", {
        className: "absolute left-2 w-5 lg:left-5 ",
        onClick: function onClick(event) {
          if (numberValue > min) {
            handleOnclickNumber(parseInt(numberValue, 10) - 1);
          }

          event.preventDefault();
        },
        children: "-"
      }), /*#__PURE__*/_jsx("button", {
        className: "absolute right-2 w-5 lg:right-5 ",
        onClick: function onClick(event) {
          if (numberValue < max) {
            handleOnclickNumber(parseInt(numberValue, 10) + 1);
          }

          event.preventDefault();
        },
        children: "+"
      }), /*#__PURE__*/_jsx("input", {
        className: "moz:appearance-none h-10 w-28 rounded-full border-zinc-200 text-center lg:w-40",
        type: "text",
        value: numberValue,
        onKeyPress: function onKeyPress(event) {
          if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
          }
        },
        min: min,
        onChange: function onChange(event) {
          event.preventDefault();
          var newValue = event.target.value;

          if (newValue === "") {
            setNumberValue("");
          } else if (newValue < min) {
            setNumberValue(min);
          } else if (newValue > max) {
            setNumberValue(max);
          } else {
            setNumberValue(newValue);
          }
        },
        onBlur: function onBlur() {
          if (numberValue < min) {
            setNumberValue(min);
          }
        }
      })]
    })
  });
};
var CheckBox = function CheckBox(_ref5) {
  var _errors$name4;

  var name = _ref5.name,
      text = _ref5.text,
      register = _ref5.register,
      errors = _ref5.errors,
      checkboxTextClassName = _ref5.checkboxTextClassName,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref5, _excluded4);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: "relative block pl-7",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", _objectSpread(_objectSpread({
        type: "checkbox"
      }, register(name, {})), {}, {
        className: "bbc-checkbox absolute left-1 top-1 cursor-pointer rounded border-bbc-silver bg-transparent focus:shadow-none focus:outline-none focus:ring-0"
      }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: checkboxTextClassName ? checkboxTextClassName : "",
        dangerouslySetInnerHTML: {
          __html: text
        }
      })]
    }), errors[name] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-sm text-red-500",
      children: (_errors$name4 = errors[name]) === null || _errors$name4 === void 0 ? void 0 : _errors$name4.message
    })]
  });
};

/***/ }),

/***/ 78762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34853);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1216);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var ReCaptcha = function ReCaptcha(props, ref) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
      ref: ref,
      sitekey: "6LeJZ68UAAAAAJZ8jxdgylEXeWL8P9Ckv7CLtE6t",
      badge: "inline",
      size: "invisible"
    }, props))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(ReCaptcha));

/***/ }),

/***/ 85882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Toast; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56727);
/* harmony import */ var common_contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72713);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97464);
/* harmony import */ var _ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30852);
/* harmony import */ var _Icon_fa_FaTimes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11856);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14388);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);












var contentStatus = {
  success: {
    title: "Send Success",
    description: "We'll contact you all right away."
  },
  error: {
    title: "Send Error",
    description: "Please check your network connection and try again"
  }
};
var timer = null;

var RenderContent = function RenderContent(_ref) {
  var sendStatus = _ref.sendStatus,
      sendContent = _ref.sendContent,
      setIsOpen = _ref.setIsOpen;

  switch (sendStatus) {
    case "success":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: "/assets/icons/checked.png",
              width: 90,
              height: 92,
              alt: "icon success",
              className: "mb-6"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-brand-800",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-sm text-bbc-gray",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.description
          })]
        });
      }

    case "error":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/assets/icons/error.png",
            width: 90,
            height: 92,
            alt: "icon error",
            className: "mb-6"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-red-500",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-sm text-bbc-red-500",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.description
          })]
        });
      }

    case "confirm":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/assets/icons/warning.png",
            width: 98,
            height: 100,
            alt: "icon error",
            className: "mx-auto mb-6",
            wrapper: {
              className: "block"
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-brand-700",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            className: "flex justify-around",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              variant: "outline",
              btnTextColor: "text-bbc-red-300 hover:text-white",
              btnBorder: "border border-bbc-red-300 hover:border-bbc-red-400",
              btnColor: "bg-transparent hover:bg-bbc-red-400",
              othersClass: "w-28",
              onClick: function onClick() {
                setIsOpen(false);
              },
              children: "No"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              othersClass: "w-28",
              onClick: function onClick() {
                sendContent.onClick();
                setIsOpen(false);
              },
              children: "Yes"
            })]
          })]
        });
      }

    case "custom":
      {
        return sendContent.element;
      }

    default:
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "mb-6 text-2xl font-semibold text-bbc-red-600",
          children: contentStatus.error.title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-sm",
          children: contentStatus.error.description
        })]
      });
  }
};

function Toast(_ref2) {
  var children = _ref2.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      sendStatus = _useState2[0],
      setSendStatus = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      sendContent = _useState3[0],
      setSendContent = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      bgAlert = _useState4[0],
      setBgAlert = _useState4[1];
  /* Handle Event */


  var closeModal = function closeModal(otherAction) {
    setIsOpen(false);

    if (otherAction) {
      try {
        otherAction(); // eslint-disable-next-line no-empty
      } catch (error) {}
    }

    clearTimeout(timer);
    document.documentElement.removeAttribute("style");
  };

  var openAlert = /*#__PURE__*/function () {
    var _ref3 = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(time, status, content, otherAction) {
      var closeModalAfterTime;
      return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              closeModalAfterTime = function _closeModalAfterTime(timeToClose) {
                return new Promise(function (resolve) {
                  timer = setTimeout(function () {
                    closeModal(otherAction);
                    resolve("closed");
                  }, timeToClose);
                });
              };

              if (content) {
                setSendContent(content);
              } else {
                setSendContent(contentStatus[status]);
              }

              _context.t0 = status;
              _context.next = _context.t0 === "success" ? 5 : _context.t0 === "error" ? 7 : _context.t0 === "confirm" ? 9 : _context.t0 === "custom" ? 11 : 13;
              break;

            case 5:
              setBgAlert("from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 7:
              setBgAlert("from-[#dd3333] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 9:
              setBgAlert("from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 11:
              setBgAlert(sendContent.bgAlert || "from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 13:
              return _context.abrupt("break", 14);

            case 14:
              setSendStatus(status);
              setIsOpen(true);

              if (!time) {
                _context.next = 19;
                break;
              }

              _context.next = 19;
              return closeModalAfterTime(time);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function openAlert(_x, _x2, _x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  /* Effect */


  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(common_contexts__WEBPACK_IMPORTED_MODULE_2__/* .ToastContext.Provider */ .uL.Provider, {
    value: {
      openAlert: openAlert,
      setOpenAlert: setIsOpen
    },
    children: [children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition */ .uT, {
      show: isOpen,
      as: "div",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Dialog */ .Vq, {
        open: isOpen,
        as: "div",
        className: "fixed inset-0  overflow-y-auto",
        onClose: closeModal,
        style: {
          zIndex: 100
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "fixed inset-0 bg-black/30",
          "aria-hidden": "true"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "min-h-screen px-4 text-center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition.Child */ .uT.Child, {
            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Dialog.Overlay */ .Vq.Overlay, {
              className: "fixed inset-0 bg-slate-900 bg-opacity-70"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
            className: "inline-block h-screen align-middle",
            "aria-hidden": "true",
            children: "\u200B"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition.Child */ .uT.Child, {
            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 scale-95",
            enterTo: "opacity-100 scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 scale-100",
            leaveTo: "opacity-0 scale-95",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
              className: "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().ToastContent), " relative inline-flex w-full flex-col  justify-center border-2 bg-gradient-to-b px-7  py-28 text-center align-middle transition-all ").concat(bgAlert, " rounded-2xl shadow-xl"),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: "absolute top-6 right-4",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("button", {
                  type: "button",
                  className: "inline-flex justify-center rounded-full border-2 border-white p-1 text-xs  font-medium text-white transition-all  hover:border-bbc-red-300 hover:text-bbc-red-300 focus:outline-none ",
                  onClick: closeModal,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Icon_fa_FaTimes__WEBPACK_IMPORTED_MODULE_5__/* .FaTimes */ .a, {
                    size: 12
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: "relative ",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(RenderContent, {
                  sendContent: sendContent,
                  sendStatus: sendStatus,
                  setIsOpen: setIsOpen
                })
              })]
            })
          })]
        })]
      })
    })]
  });
}

/***/ }),

/***/ 88279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87536);
/* harmony import */ var common_contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72713);
/* harmony import */ var common_fetch_getGAUserID__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(12453);
/* harmony import */ var common_fetch_post__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92559);
/* harmony import */ var common_trigger__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(62951);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Icon_bi_BiLoaderAlt__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7778);
/* harmony import */ var components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66865);
/* harmony import */ var components_atoms_Recaptcha_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78762);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31741);
/* harmony import */ var components_atoms_Toast__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85882);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













/** ========== */




var FormCountry = function FormCountry(_ref) {
  var country_id = _ref.country_id;

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(common_contexts__WEBPACK_IMPORTED_MODULE_3__/* .ToastContext */ .uL),
      openAlert = _useContext.openAlert;

  var _useForm = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .useForm */ .cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      clearErrors = _useForm.clearErrors,
      _useForm$formState = _useForm.formState,
      isSubmitting = _useForm$formState.isSubmitting,
      errors = _useForm$formState.errors;

  var recaptchaRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
      var token, GAUserID, dataSend;
      return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return recaptchaRef.current.executeAsync();

            case 2:
              token = _context.sent;

              if (token) {
                GAUserID = (0,common_fetch_getGAUserID__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)();
                dataSend = _objectSpread({}, data);
                dataSend.client_id = GAUserID ? GAUserID : "";
                dataSend.website_id = "1";
                dataSend.company_country_id = country_id;

                try {
                  (0,common_fetch_post__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    api: "".concat("https://core.test-lp.bbcincorp.com", "/api/portal/contact_form/question"),
                    data: dataSend,
                    token: token
                  }).then(function (res) {
                    if (res.state) {
                      (0,common_trigger__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("contact_form", dataSend, "Contact form");
                      openAlert(2000, "success");
                      reset();
                    } else {
                      openAlert(3000, "error");
                      console.log("error");
                    }
                  })["catch"](function (e) {
                    openAlert(3000, "error");
                    console.log("error", e);
                  });
                } catch (e) {
                  clearErrors();
                  openAlert(3000, "error");
                  console.log("error", e);
                }
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("form", {
    onSubmit: handleSubmit(onSubmit),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "mb-6 lg:mb-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__/* .InputText */ .oH, {
        register: register,
        errors: errors,
        name: "first_name",
        placeholder: "Name*",
        requiredText: "Name is required"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "mb-6 lg:mb-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__/* .InputEmail */ .j7, {
        register: register,
        errors: errors
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "mb-6 lg:mb-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__/* .InputText */ .oH, {
        as: "textarea",
        register: register,
        errors: errors,
        name: "message",
        placeholder: "Message*",
        requiredText: "Message is required"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
      className: "flex flex-wrap items-center justify-between",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: "col-12 mb-6 text-center lg:col-auto  lg:mb-0",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
          className: "inline-block",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Recaptcha_index__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            ref: recaptchaRef,
            className: "mx-auto w-max"
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: "col-12 text-center lg:col-auto",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          type: "submit",
          style: {
            minWidth: "170px"
          },
          disabled: isSubmitting,
          children: [isSubmitting && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Icon_bi_BiLoaderAlt__WEBPACK_IMPORTED_MODULE_6__/* .BiLoaderAlt */ .s, {
            className: "mr-2 inline-block animate-spin",
            size: 20
          }), "Send Your Message"]
        })
      })]
    })]
  });
};
/** ========== */


var FormCountries = function FormCountries(_ref3) {
  var title = _ref3.title,
      description = _ref3.description,
      descriptionClass = _ref3.descriptionClass,
      contentBottom = _ref3.contentBottom,
      country_id = _ref3.country_id;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
    className: "rounded-3xl bg-white px-3  py-6 lg:px-10 lg:py-[50px]",
    style: {
      boxShadow: "0px 16px 40px rgba(181, 181, 181, 0.25)"
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      text: title,
      className: "mb-6 text-bbc-30px font-semibold capitalize text-bbc-brand-800 lg:mb-10 lg:text-center lg:text-bbc-40px"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
      className: "".concat(descriptionClass ? descriptionClass : "mb-6 text-center lg:mb-10"),
      children: description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Toast__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(FormCountry, {
        country_id: country_id
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      children: contentBottom
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FormCountries);
FormCountries.defaultProps = {
  title: "",
  description: "",
  nameProps: {},
  emailProps: {},
  messageProps: {}
};
/** ========== */

/***/ }),

/***/ 37768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31741);
/* harmony import */ var components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69156);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


/* ========== */





var Component = function Component(_ref) {
  var data = _ref.data,
      title = _ref.title,
      description = _ref.description,
      defaultActiveKey = _ref.defaultActiveKey,
      multipleOpen = _ref.multipleOpen,
      buttonClass = _ref.buttonClass,
      panelClass = _ref.panelClass;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      text: title || "Frequently Asked Questions",
      className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800  lg:text-bbc-40px "
    }), description ? description.trim().length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
      className: "mb-6 text-center lg:mb-10",
      children: description
    }) :
    /*#__PURE__*/
    // <p className="text-center mb-6 lg:mb-10">
    //   Know more about our nominee service with commonly asked questions.
    // </p>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      data: data,
      haveTabs: !Array.isArray(data),
      defaultActiveKey: defaultActiveKey || false,
      multipleOpen: multipleOpen || false,
      buttonClass: buttonClass,
      panelClass: panelClass
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);

/***/ }),

/***/ 95183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);







/** ========== */




var RequiredDocument = function RequiredDocument(_ref) {
  var _data$content;

  var title = _ref.title,
      data = _ref.data,
      sectionClassName = _ref.sectionClassName,
      backgroundImage = _ref.backgroundImage;
  var checkBtnRight = data.button_image && Object.keys(data.button_image).length > 0;

  var renderButton = function renderButton() {
    var button = data.button;

    if (button) {
      if (button.type === "contact-us") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "mt-6 text-center lg:text-left",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            href: button.link,
            className: "inline-block rounded-[50px] px-6 py-2 text-white transition-all hover:bg-bbc-brand-600 ".concat(button.noBackground ? "border border-white font-medium hover:border-bbc-brand-600" : "bg-bbc-primary font-semibold"),
            children: button.text
          })
        });
      }

      if (button.type === "talk-to") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "mt-6",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            as: "button",
            onClick: /*#__PURE__*/(0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
              return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.next = 3;
                      return Tawk_API.toggle();

                    case 3:
                      _context.next = 8;
                      break;

                    case 5:
                      _context.prev = 5;
                      _context.t0 = _context["catch"](0);
                      console.error();

                    case 8:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[0, 5]]);
            })),
            children: button.text
          })
        });
      }

      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "mt-6 text-center lg:text-left",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
          href: button.link,
          className: "inline-block rounded-[50px] px-6 py-2 text-white transition-all hover:bg-bbc-brand-600 ".concat(button.noBackground ? "border border-white font-medium hover:border-bbc-brand-600" : "bg-bbc-primary font-semibold"),
          children: button.text
        })
      });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    className: "relative ".concat(sectionClassName ? sectionClassName : "bg-bbc-brand-800 py-[50px]"),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "container relative z-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: "row",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "".concat(checkBtnRight ? "lg:col-8" : "lg:col-12"),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            as: "h2",
            text: title,
            className: "mb-6 text-center text-bbc-30px font-semibold capitalize text-white lg:text-left lg:text-bbc-40px"
          }), (data === null || data === void 0 ? void 0 : (_data$content = data.content) === null || _data$content === void 0 ? void 0 : _data$content.length) > 0 && data.content.map(function (item, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
              children: [item.title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                className: "mb-2 text-white ",
                dangerouslySetInnerHTML: {
                  __html: item.title
                }
              }), item.listContent && item.listContent.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("ul", {
                className: "lg:mb-2",
                children: item.listContent.map(function (element, i) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("li", {
                    className: "   relative mb-2 pl-[22px] text-white before:absolute before:top-2.5 before:left-[5px] before:inline-block before:h-1.5 before:w-1.5 before:rounded-full before:bg-bbc-secondary-100 before:content-['']",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                      dangerouslySetInnerHTML: {
                        __html: element.text
                      }
                    }), element.content && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("ul", {
                      children: element.content.map(function (element, index) {
                        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
                          className: "relative mb-2 pl-[22px] text-white  before:absolute before:top-2.5 before:left-[5px] before:inline-block before:h-1 before:w-1 before:rounded-full before:bg-white before:content-['']",
                          children: element
                        }, index);
                      })
                    })]
                  }, i);
                })
              })]
            }, index);
          }), (data === null || data === void 0 ? void 0 : data.note) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "m-0 text-white",
            dangerouslySetInnerHTML: {
              __html: data.note
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "text-center lg:text-left",
            children: renderButton()
          })]
        }), checkBtnRight && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "lg:col-4",
          children: data.button_image.type && data.button_image.type === "post" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
            href: data.button_image.uri,
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: data.button_image.src,
              alt: data.button_image.alt,
              width: data.button_image.width || 350,
              height: data.button_image.height || 350,
              className: "transition-all duration-200 hover:scale-105",
              wrapper: {
                className: "mt-6 lg-mt:0 w-full h-full z-0 flex justify-center items-center"
              }
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            href: data.button_image.uri,
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: data.button_image.src,
              alt: data.button_image.alt,
              width: 350,
              height: 350,
              className: "transition-all duration-200 hover:scale-105",
              wrapper: {
                className: "mt-6 lg-mt:0 w-full h-full z-0 flex justify-center items-center"
              }
            })
          })
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      src: backgroundImage,
      width: 1920,
      height: 737,
      className: "h-full w-full",
      wrapper: {
        className: "absolute top-0 left-0 w-full h-full z-0"
      }
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RequiredDocument);
RequiredDocument.defaultProps = {
  title: "",
  data: {},
  sectionClassName: ""
};
/** ========== */

/***/ }),

/***/ 7955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaCheckCircle.js
var FaCheckCircle = __webpack_require__(59699);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/FormCountries/index.js
var FormCountries = __webpack_require__(88279);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/Faqs/index.js
var Faqs = __webpack_require__(37768);
// EXTERNAL MODULE: ./components/organisms/RequiredDocument/index.js
var RequiredDocument = __webpack_require__(95183);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(30266);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(809);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./common/source-function/numberFormat.js
var numberFormat = __webpack_require__(80077);
// EXTERNAL MODULE: ./common/source-function/scanPrice.js
var scanPrice = __webpack_require__(38951);
// EXTERNAL MODULE: ./common/source-function/totalPrice.js
var totalPrice = __webpack_require__(7648);
// EXTERNAL MODULE: ./components/atoms/ButtonNew/index.js
var ButtonNew = __webpack_require__(30852);
// EXTERNAL MODULE: ./components/templates/vn/accounting-and-auditing/AccountingAuditing/ServiceFeeCalculator/Index.module.scss
var Index_module = __webpack_require__(27652);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/vn/accounting-and-auditing/AccountingAuditing/ServiceFeeCalculator/AccountingTab.js









var AccountingTab = function AccountingTab(_ref) {
  var _accountingService$ty;

  var accountingService = _ref.accountingService,
      setAccountingValue = _ref.setAccountingValue,
      accountingValue = _ref.accountingValue;
  var transaction = ((_accountingService$ty = accountingService.types[0]) === null || _accountingService$ty === void 0 ? void 0 : _accountingService$ty.transaction) || {};
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-6 text-center lg:mb-8",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
          children: "Accounting"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-6 flex items-center justify-center gap-x-7",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        className: "h-8 w-20 rounded-full border border-bbc-neutral-600 text-center outline-none",
        value: (0,numberFormat/* default */.Z)(accountingValue),
        onChange: function onChange(e) {
          return setAccountingValue(e.target.value);
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Transactions per month"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-0 border-0 lg:mb-6 lg:border-b lg:px-6",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        className: "form-input mb-4 h-1 w-full appearance-none rounded-full bg-bbc-primary focus:shadow-none focus:outline-0 focus:ring-0 ".concat((Index_module_default()).sfc_slider),
        min: transaction.min || 1,
        max: transaction.max || 1000,
        step: transaction.step || 1,
        value: accountingValue,
        onChange: function onChange(e) {
          return setAccountingValue(e.target.value);
        },
        type: "range"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-6 flex justify-between",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: (0,numberFormat/* default */.Z)(transaction.min || 1)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: (0,numberFormat/* default */.Z)(transaction.max || 1000)
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex flex-col items-center gap-y-3 md:flex-row ",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "pb-0 text-center lg:pb-4",
          children: "* Greater than 90 transactions per month? Please contact us."
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "hidden px-6 lg:block",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-6 text-lg font-semibold text-bbc-brand-700",
        children: "What\u2018s included in Accounting package?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "mt-2 mb-2 flex items-start first:mt-0",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaCheckCircle/* FaCheckCircle */.F, {
              className: "mr-2.5 mt-1 block text-bbc-brand-600",
              size: 16
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "Monthly/quarterly and yearly tax preparation"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "mt-2 mb-2 flex items-start first:mt-0",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaCheckCircle/* FaCheckCircle */.F, {
              className: "mr-2.5 mt-1 block text-bbc-brand-600",
              size: 16
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "Bookkeeping service and FSs compilation"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "mt-2 flex items-start first:mt-0",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheckCircle/* FaCheckCircle */.F, {
            className: "mr-2.5 mt-1 block text-bbc-brand-600",
            size: 16
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "Appointment of Chief Accountant"
          })]
        })]
      })]
    })]
  });
};

/* harmony default export */ var ServiceFeeCalculator_AccountingTab = (AccountingTab);
AccountingTab.defaultProps = {
  accountingService: {},
  setAccountingValue: function setAccountingValue() {},
  accountingValue: "",
  xero: {},
  setXero: function setXero() {}
};
;// CONCATENATED MODULE: ./components/templates/vn/accounting-and-auditing/AccountingAuditing/ServiceFeeCalculator/index.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var initState = {
  tabIndex: 0,
  paymentType: "monthly",
  accountingValue: 1
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case "fee_update_state":
      return _objectSpread(_objectSpread({}, state), action.payload);

    default:
      return state;
  }
};

var ServiceFeeCalculator = function ServiceFeeCalculator(_ref) {
  var _services$, _services$2, _services$2$xero, _state$accountingServ2, _state$accountingServ3, _state$accountingServ4, _services$state$tabIn, _services$state$tabIn2, _services$state$tabIn3, _services$state$tabIn4, _state$accountingServ5, _services$state$tabIn5, _state$accountingServ6, _state$accountingServ7, _state$accountingServ8;

  var services = _ref.services;

  var priceAccountingPerMonth = function priceAccountingPerMonth(pricing, transaction) {
    var xero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var month = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var price = (0,scanPrice/* default */.Z)(pricing, transaction);
    return (parseFloat(price) + parseFloat(xero)) * month;
  };

  var _useReducer = (0,react.useReducer)(reducer, _objectSpread(_objectSpread({}, initState), {}, {
    accountingService: services[0],
    xero: _objectSpread(_objectSpread({}, (_services$ = services[0]) === null || _services$ === void 0 ? void 0 : _services$.xero), {}, {
      checked: (_services$2 = services[0]) === null || _services$2 === void 0 ? void 0 : (_services$2$xero = _services$2.xero) === null || _services$2$xero === void 0 ? void 0 : _services$2$xero["default"]
    })
  })),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var updateState = function updateState(payload) {
    dispatch({
      type: "fee_update_state",
      payload: payload
    });
  };

  var setXero = function setXero(checked) {
    updateState({
      xero: _objectSpread(_objectSpread({}, state.xero), {}, {
        checked: checked
      })
    });
  };

  var setAccountingValue = function setAccountingValue(value) {
    var _state$accountingServ;

    var valueTemp = value === "" ? "" : "".concat(value.replaceAll(",", ""));
    var accType = (_state$accountingServ = state.accountingService) === null || _state$accountingServ === void 0 ? void 0 : _state$accountingServ.types.find(function (item) {
      return item.key === state.paymentType;
    });
    var accountingTemp = parseFloat(valueTemp);

    if (!Number.isNaN(accountingTemp) && accType) {
      var _accType$transaction, _accType$transaction2;

      if (accountingTemp >= ((_accType$transaction = accType.transaction) === null || _accType$transaction === void 0 ? void 0 : _accType$transaction.min) && accountingTemp <= ((_accType$transaction2 = accType.transaction) === null || _accType$transaction2 === void 0 ? void 0 : _accType$transaction2.max)) {
        updateState({
          accountingValue: accountingTemp
        });
      }
    } else if (value === "") {
      updateState({
        accountingValue: ""
      });
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: "accounting-auditing",
    className: "lg:shadow-bbc rounded-3xl lg:bg-white",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "row",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-12 lg:col-6",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "pb-7 pt-0 lg:pb-9 lg:pt-9",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceFeeCalculator_AccountingTab, {
              setAccountingValue: setAccountingValue,
              accountingValue: state.accountingValue,
              accountingService: state.accountingService,
              xero: state.xero,
              setXero: setXero
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-12 mb-10 lg:col-6 lg:mb-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "h-full rounded-3xl bg-bbc-gradient-3 py-8 px-6 lg:py-12 lg:px-11",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mb-8 flex items-end justify-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "text-5xl font-semibold text-white",
              children: state.tabIndex === 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [(_state$accountingServ2 = state.accountingService) === null || _state$accountingServ2 === void 0 ? void 0 : _state$accountingServ2.currencySymbol, (0,numberFormat/* default */.Z)(priceAccountingPerMonth((_state$accountingServ3 = state.accountingService) === null || _state$accountingServ3 === void 0 ? void 0 : (_state$accountingServ4 = _state$accountingServ3.types.find(function (item) {
                  return item.key === state.paymentType;
                })) === null || _state$accountingServ4 === void 0 ? void 0 : _state$accountingServ4.pricing, state.accountingValue, state.xero.checked ? state.xero.value : 0))]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "text-lg font-semibold text-white",
              children: state.tabIndex === 0 ? "/Month" : ""
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: "mb-1 text-center text-white",
            children: ["Total yearly estimated cost for", " ", (_services$state$tabIn = services[state.tabIndex]) !== null && _services$state$tabIn !== void 0 && (_services$state$tabIn2 = _services$state$tabIn.types[state.auditingIndexType]) !== null && _services$state$tabIn2 !== void 0 && _services$state$tabIn2.costFor ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: state.revenue > 0 ? (_services$state$tabIn3 = services[state.tabIndex]) === null || _services$state$tabIn3 === void 0 ? void 0 : (_services$state$tabIn4 = _services$state$tabIn3.types[state.auditingIndexType]) === null || _services$state$tabIn4 === void 0 ? void 0 : _services$state$tabIn4.costFor : (_state$accountingServ5 = state.accountingService) === null || _state$accountingServ5 === void 0 ? void 0 : _state$accountingServ5.name
            }) : (_services$state$tabIn5 = services[state.tabIndex]) === null || _services$state$tabIn5 === void 0 ? void 0 : _services$state$tabIn5.name, ":"]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: "mb-8 text-center text-lg font-semibold text-white",
            children: [(_state$accountingServ6 = state.accountingService) === null || _state$accountingServ6 === void 0 ? void 0 : _state$accountingServ6.currencySymbol, (0,numberFormat/* default */.Z)((0,totalPrice/* default */.Z)([priceAccountingPerMonth((_state$accountingServ7 = state.accountingService) === null || _state$accountingServ7 === void 0 ? void 0 : (_state$accountingServ8 = _state$accountingServ7.types.find(function (item) {
              return item.key === state.paymentType;
            })) === null || _state$accountingServ8 === void 0 ? void 0 : _state$accountingServ8.pricing, state.accountingValue, state.xero.checked ? state.xero.value : 0, 12)]))]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mb-8 flex justify-center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
              as: "button",
              btnColor: "bg-white",
              btnTextColor: "text-bbc-primary",
              onClick: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return Tawk_API.toggle();

                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })),
              children: "Talk To Us"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-10 text-center text-white",
            children: "* Applied to trading without import/export activities, service businesses. Fees applied to other business lines like manufacturing, construction, etc. will be adjusted upward."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "text-center text-white",
            children: "* Excluded: VAT 10%"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "col-12 block px-6 lg:col-6 lg:hidden",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-2 text-base font-medium text-bbc-brand-700",
          children: "What\u2018s included in Accounting package?"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: "mt-2 mb-2 flex items-start first:mt-0",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaCheckCircle/* FaCheckCircle */.F, {
                className: "mr-2.5 mt-1 block text-bbc-brand-600",
                size: 16
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Monthly/quarterly and yearly tax preparation"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: "mt-2 mb-2 flex items-start first:mt-0",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaCheckCircle/* FaCheckCircle */.F, {
                className: "mr-2.5 mt-1 block text-bbc-brand-600",
                size: 16
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Bookkeeping service and FSs compilation"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: "mt-2 flex items-start first:mt-0",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FaCheckCircle/* FaCheckCircle */.F, {
                className: "mr-2.5 mt-1 block text-bbc-brand-600",
                size: 16
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Appointment of Chief Accountant"
            })]
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var AccountingAuditing_ServiceFeeCalculator = (ServiceFeeCalculator);
ServiceFeeCalculator.defaultProps = {
  services: []
};
;// CONCATENATED MODULE: ./components/templates/vn/accounting-and-auditing/AccountingAuditing/index.js





var AccountingAuditing = function AccountingAuditing(_ref) {
  var services = _ref.services;
  // ******
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "container",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "row justify-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "col-12 mb-6 lg:col-10 lg:mb-10",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: "Accounting Service",
          className: "title-h2 mb-6 text-center text-3xl font-semibold text-bbc-brand-700 lg:mb-10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-0 leading-bbc-26",
          children: "The fee for our accounting service will mainly depend on the number of your company\u2019s monthly transactions:"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-12 lg:col-10",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(AccountingAuditing_ServiceFeeCalculator, {
          services: services
        })
      })]
    })
  });
};

/* harmony default export */ var accounting_and_auditing_AccountingAuditing = (AccountingAuditing);
// EXTERNAL MODULE: ./components/templates/vn/accounting-and-auditing/TaxFilingServices/Index.module.scss
var TaxFilingServices_Index_module = __webpack_require__(79383);
var TaxFilingServices_Index_module_default = /*#__PURE__*/__webpack_require__.n(TaxFilingServices_Index_module);
;// CONCATENATED MODULE: ./components/templates/vn/accounting-and-auditing/TaxFilingServices/index.js










var TaxFilingServices = function TaxFilingServices(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
        className: "bbc-title mb-6 text-center text-3xl font-semibold capitalize text-bbc-brand-700",
        text: data.title,
        as: "h2"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-6 text-left font-medium lg:mb-20 lg:text-center lg:font-normal",
        children: data.subTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        className: "block list-disc pl-5 text-base lg:hidden",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "VAT, CIT, PIT on the quarterly or monthly basis"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "CIT or PIT\u2019s annual finalization"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Annual license tax"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Monthly or quarterly report for using invoice"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "block py-4 px-0 lg:hidden lg:px-4",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-2 text-base font-normal leading-6",
          children: "Plus, registering for a personal tax code is also an essential part that needs to be taken care of."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: " text-base font-normal leading-6",
          children: "Let BBCIncorp do all the hassles for you by completing all the filing compliance on your behalf!"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-7 flex justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "lg:shadow-bbc relative rounded-lg shadow-none ",
          style: {
            maxWidth: "540px"
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
            src: "assets/images/vn/accounting-and-auditing/tax_filing-vn-accounting.png",
            alt: "tax-filing-services",
            loading: "eager",
            className: "rounded-none lg:rounded-t-lg ",
            width: 540,
            height: 304
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "hidden py-4 px-0 lg:block lg:px-4",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "mb-2 text-base font-normal italic leading-6 lg:mb-1 lg:text-sm",
              children: "Plus, registering for a personal tax code is also an essential part that needs to be taken care of."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: " text-base font-normal italic leading-6 lg:text-sm",
              children: "Let BBCIncorp do all the hassles for you by completing all the filing compliance on your behalf!"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "shadow-bbc absolute hidden ".concat((TaxFilingServices_Index_module_default()).item),
            children: "VAT, CIT, PIT on the quarterly or monthly basis"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "shadow-bbc absolute hidden ".concat((TaxFilingServices_Index_module_default()).item),
            children: "CIT or PIT\u2019s annual finalization"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "shadow-bbc absolute hidden ".concat((TaxFilingServices_Index_module_default()).item),
            children: "Annual license tax"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "shadow-bbc absolute hidden ".concat((TaxFilingServices_Index_module_default()).item),
            children: "Monthly or quarterly report for using invoice"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
          onClick: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
            return regenerator_default().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return Tawk_API.toggle();

                  case 2:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          })),
          children: "Tell Us Your Case"
        })
      })]
    })
  });
};

/* harmony default export */ var accounting_and_auditing_TaxFilingServices = (TaxFilingServices);
TaxFilingServices.defaultProps = {
  data: [],
  children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
};
;// CONCATENATED MODULE: ./components/templates/vn/accounting-and-auditing/index.js













var Component = function Component(_ref) {
  var _data$banner, _data$banner2, _data$banner3, _data$accountingServi;

  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
        minHeightBanner: "banner-min-h-635",
        title: "Accounting,<br/>Auditing & Tax Filing<br/>in Vietnam",
        bgColor: "bg-bbc-country",
        breadcrumbs: data === null || data === void 0 ? void 0 : (_data$banner = data.banner) === null || _data$banner === void 0 ? void 0 : _data$banner.breadcrumbs,
        leftClassName: "relative mt-4 lg:mt-0 col-12 lg:col-7",
        leftContent: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: " mb-6 lg:mt-10 lg:mb-10",
          children: (data === null || data === void 0 ? void 0 : (_data$banner2 = data.banner) === null || _data$banner2 === void 0 ? void 0 : _data$banner2.options.length) > 0 && (data === null || data === void 0 ? void 0 : (_data$banner3 = data.banner) === null || _data$banner3 === void 0 ? void 0 : _data$banner3.options.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "mb-2 flex items-center last:mb-0 ",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheckCircle/* FaCheckCircle */.F, {
                className: "mr-2 text-[#21B350]",
                size: 12
              }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "font-medium leading-6 text-bbc-brand-800",
                children: item
              })]
            }, index);
          }))
        }),
        rightClassName: "col-12 lg:col-5 pb-[26px]",
        rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/images/common/accounting-auditing-banner.png",
          width: 622,
          height: 400,
          alt: "accounting services in Vietnam",
          className: "lg:absolute lg:top-24",
          wrapper: {
            className: "bbc-banner-image-country banner-lg-top-12"
          },
          priority: true
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            text: "Our Services",
            className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800 lg:mb-10 lg:text-bbc-40px"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-6 leading-bbc-26 lg:mb-4",
            children: "All companies in Vietnam have to comply with the requirements set forth in the Law on Accounting and the Vietnam Accounting Standard. If your business is new to the country, you may find these financial reporting requirements troublesome and time-consuming."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-6 leading-bbc-26 lg:mb-4",
            children: "That\u2019s why BBCIncorp is here, to provide you with a set of comprehensive accounting services. When using our services, you can relieve your company from the heavy burden of compliance. You will get more time and resources to focus more on running your company in Vietnam."
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(accounting_and_auditing_AccountingAuditing, {
        services: data === null || data === void 0 ? void 0 : (_data$accountingServi = data.accountingService) === null || _data$accountingServi === void 0 ? void 0 : _data$accountingServi.serviceFees,
        title: "Accounting Service",
        country: data.country,
        data: data === null || data === void 0 ? void 0 : data.accountingService
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(accounting_and_auditing_TaxFilingServices, {
        data: data.taxFilingServices
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(RequiredDocument/* default */.Z, {
      sectionClassName: "mb-10 lg:mb-20 pt-14 pb-20",
      backgroundImage: "/assets/images/common/required-documents.png",
      title: "What you'll need to prepare",
      data: data === null || data === void 0 ? void 0 : data.dataRequiredDocuments
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "relative",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container relative z-10",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "m-auto lg:col-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormCountries/* default */.Z, {
            title: data.dataFormContact.title,
            description: data.dataFormContact.description,
            country_id: 244
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:col-10 lg:mx-auto",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z, {
            data: data === null || data === void 0 ? void 0 : data.dataFaqs,
            description: "Get to know more with frequently asked questions."
          })
        })
      })
    })]
  });
};

/* harmony default export */ var accounting_and_auditing = (Component);
;// CONCATENATED MODULE: ./pages/vn/accounting-and-auditing/data.json
var data_namespaceObject = JSON.parse('{"country":"vn","banner":{"breadcrumbs":[{"title":"Home","uri":"/"},{"title":"Accounting, Auditing & Tax Filing"}],"options":["Cloud Accounting","Reasonable & Transparent Pricing","Effective Communication","CPA Certified Expert"]},"dataWhyMakeUs":[{"icon":{"src":"/assets/icons/user-headset.svg","altText":"user-headset"},"title":"Local qualified experts","description":"Our team comprises local experts with relevant qualifications and years of hands-on experience in varied industries"},{"icon":{"src":"/assets/icons/sliders-h.svg","altText":"sliders-h"},"title":"Flexible solutions","description":"We offer multiple packages that easily comfort needs of businesses ranging from startups to small and medium companies"},{"icon":{"src":"/assets/icons/clock.svg","altText":"clock"},"title":"Accurate and timely reports","description":"You can definitely rely on our management reports for monitoring your operation as we use strict framework and automation for producing such reports"},{"icon":{"src":"/assets/icons/users.svg","altText":"users"},"title":"Excellent communication","description":"No worry of jargon anymore. We only use plain English to communicate with our clients to help them make better-informed decisions"},{"icon":{"src":"/assets/icons/coding.svg","altText":"coding"},"title":"Seamless technical integration","description":"WWhatever accounting software you use i.e. Xero, Quickbooks or local mandated ones, we can easily adapt to meet your requirements"}],"accountingService":{"serviceFees":[{"key":"accounting","name":"accounting","currencySymbol":"US$","xero":{"value":0,"default":false},"types":[{"key":"monthly","name":"monthly","transactionUnitText":"Transactions per month","pricePer":"month","costFor":"accounting","note":"<p>* Applied to trading without import/export activities, service businesses. Fees applied to other business lines like manufacturing, construction, etc. will be adjusted upward.</p><p class=\\"mb-0\\">* Excluded: VAT 10%</p>","currencySymbol":"US$","transaction":{"min":1,"max":90,"step":1,"note":"<p>* Greater than 90 transactions per month? Please contact us.</a>"},"pricing":[{"value":10,"price":35},{"value":20,"price":65},{"value":30,"price":90},{"value":40,"price":120},{"value":50,"price":150},{"value":60,"price":183},{"value":70,"price":208},{"value":80,"price":233},{"value":90,"price":258}],"content":"<h3 class=\\"text-center\\">What included in Accounting package</h3><div class=\\"row justify-content-center\\"><div class=\\"col-auto\\"><ul class=\\"mb-0\\"><li><svg class=\\"mr-2\\" stroke=\\"#7bde45\\" fill=\\"#7bde45\\" stroke-width=\\"0\\" viewBox=\\"0 0 512 512\\" height=\\"1em\\" width=\\"1em\\" xmlns=\\"http://www.w3.org/2000/svg\\"><path d=\\"M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z\\"></path></svg>Monthly/quarterly and yearly tax preparation</li><li><svg class=\\"mr-2\\" stroke=\\"#7bde45\\" fill=\\"#7bde45\\" stroke-width=\\"0\\" viewBox=\\"0 0 512 512\\" height=\\"1em\\" width=\\"1em\\" xmlns=\\"http://www.w3.org/2000/svg\\"><path d=\\"M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z\\"></path></svg>Bookkeeping service and FSs compilation</li><li><svg class=\\"mr-2\\" stroke=\\"#7bde45\\" fill=\\"#7bde45\\" stroke-width=\\"0\\" viewBox=\\"0 0 512 512\\" height=\\"1em\\" width=\\"1em\\" xmlns=\\"http://www.w3.org/2000/svg\\"><path d=\\"M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z\\"></path></svg>Appointment of Chief Accountant</li></ul></div></div>"}]}]},"taxFilingServices":{"title":"Tax Filing Services","subTitle":"All entities are subject to file a tax return when incorporated in Vietnam. You are required to file the following taxes:","required":["VAT, CIT, PIT on the quarterly or monthly basis","CIT or PIT’s annual finalization","Annual license tax","Monthly or quarterly report for using invoice"]},"dataRequiredDocuments":{"note":"<a rel=\\"nofollow\\" target=\\"_blank\\" href=\\"/files/certified-true-copy-guide.pdf\\"><span class=\'text-bbc-secondary-300 font-medium\' style=\'text-decoration:underline\'>* See certified true copy guide</span></a>","content":[{"listContent":[{"text":"All invoices in the reporting period"},{"text":"Company bank statements"},{"text":"Company incorporation documents"}]}]},"dataFormContact":{"title":"Need help with your accounting reports in Vietnam?","description":"Don’t hesitate to drop us your queries."},"dataFaqs":[{"name":"Where can I learn about the Vietnam Accounting Standards?","content":"<p>The Vietnam Accounting Standards (VASs) are built based on the International Financial Reporting Standards (IFRS) but customized to fit the local circumstances. Go through the keypoint of the Vietnam Accounting Standards.</p>"},{"name":"What is the official language and currency used in the Vietnam Accounting Standards?","content":"<p>There is no regulation about an official language or currency in the accounting reports. You are free to complete your reports with your desired language or currency as long as you notify your direct supervisory tax authority.</p><p>However, when it comes to preparing financial statements, Vietnamese and Vietnam Dong are compulsory by law.</p>"},{"name":"What is the accounting period of a newly-established company in Vietnam?","content":"<p>The accounting period will start from the first effective day of the Business Registration Certificate to the last day of the monthly, quarterly, or yearly accounting period.</p>"},{"name":"How can I submit my data?","content":"<p>There are 3 methods:</p><ul><li>Via email</li><li>Via cloud storage</li><li>Via remote access to your internal accounting system</li></ul>"}]}');
;// CONCATENATED MODULE: ./pages/vn/accounting-and-auditing/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "vn",
    page: data === null || data === void 0 ? void 0 : data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(accounting_and_auditing, {
      data: data_namespaceObject,
      posts: data === null || data === void 0 ? void 0 : data.posts
    })
  });
}

/***/ }),

/***/ 45178:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vn/accounting-and-auditing",
      function () {
        return __webpack_require__(7955);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14388:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ToastContent":"Index_ToastContent__WZ1XO"};

/***/ }),

/***/ 27652:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sfc_slider":"Index_sfc_slider__BjscX"};

/***/ }),

/***/ 79383:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"Index_item__fBSc8"};

/***/ }),

/***/ 34853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm; }
});

// UNUSED EXPORTS: ReCAPTCHA

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);


/***/ }),

/***/ 30266:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3105,9593,9885,4090,9738,7447,9156,9774,2888,179], function() { return __webpack_exec__(45178); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);